import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import SoftBox from "StyleFeatures/SoftBox";
import SoftTypography from "StyleFeatures/SoftTypography";
import SoftInput from "StyleFeatures/SoftInput";
import SoftButton from "StyleFeatures/SoftButton";
import CoverLayout from "Common/CoverLayout";
import curved9 from "assets/images/curved-images/curved-6.jpg";
import { toast, ToastContainer } from "react-toastify";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    // ❌ token check
    if (!token) {
      toast.error("Invalid or expired reset link");
      return;
    }

    // ❌ validation
    if (!password || password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    if (password !== confirmPass) {
      setError("Passwords do not match");
      return;
    }

    try {
      setLoading(true);

      const res = await axiosInstance.post(API.auth.confirmPassword, {
        token,
        password: password,
      });

      const data = res?.data;

      if (data?.success === false) {
        throw new Error(data.message || "Reset failed");
      }

      toast.success("Password reset successful!");

      setTimeout(() => {
        navigate("/signIn");
      }, 1500);
    } catch (err) {
      const msg = err.response?.data?.message || err.message || "Something went wrong";

      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CoverLayout title="Reset Password" description="Enter your new password" image={curved9}>
      <SoftBox component="form" onSubmit={handleSubmit}>
        <ToastContainer position="top-left" />

        {/* New Password */}
        <SoftBox mb={2}>
          <SoftTypography variant="caption">New Password</SoftTypography>
          <SoftInput
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </SoftBox>

        {/* Confirm Password */}
        <SoftBox mb={2}>
          <SoftTypography variant="caption">Confirm Password</SoftTypography>
          <SoftInput
            type="password"
            value={confirmPass}
            onChange={(e) => setConfirmPass(e.target.value)}
          />
        </SoftBox>

        {/* Error */}
        {error && (
          <SoftTypography color="error" variant="caption">
            {error}
          </SoftTypography>
        )}

        {/* Submit */}
        <SoftButton type="submit" fullWidth variant="gradient" color="info">
          {loading ? "Resetting..." : "Reset Password"}
        </SoftButton>
      </SoftBox>
    </CoverLayout>
  );
}

export default ResetPassword;
